import DEFAULT_PEOPLE from '@discover-data/stores/restaurant/model/people/default';
import DEFAULT_SESSION from '@discover-data/stores/restaurant/model/session/default';
import { sessionSlugs } from '@discover-lib/getCitySlug';

export default function getRestaurantHref(
  slug: string | null | undefined,
  people: number,
  hash?: string,
  session?: SessionType
): string {
  if (!slug) {
    return '#';
  }

  // The restaurant page reads its meal period from the trailing path segment and defaults to dinner without one.
  const sessionSuffix = session && session !== DEFAULT_SESSION ? `/${sessionSlugs[session]}` : '';
  const peopleQuery = people === DEFAULT_PEOPLE ? '' : `?people=${people}`;
  const fragment = hash ? `#${hash}` : '';

  return `${slug}${sessionSuffix}${peopleQuery}${fragment}`;
}
